import { mapActions, mapMutations, mapGetters, mapStates } from './../baseModule'
import Couchdb from 'src/services/Couchdb'
import connections from '../../config/connections'

const collection = 'customers'
const singleName = 'customer'
const pluralName = 'customers'
const model = {
  uc: '',
  cpf: '',
  nationalId: '', // RG
  birthdate: '',
  holder: '',
  aka: '',
  motherName: '',
  carrer: '',
  politician: false,
  phone1: '',
  phone2: '',
  address: {
    street: '',
    number: '',
    neighborhood: '',
    city: '',
    zip: '',
    complement: ''
  },
  observartion: '',
  nis: '',
  regularity: '',
  contemplated: null
}
const validations = {
  initialData: {
    uc: { required: true, min: 2 },
    cpf: { required: true, cpf: true }
  },
  personalData: {
    motherName: { min: 5 },
    birthdate: { min: 10, max: 10 },
    nationalId: { required: true, min: 3 },
    holder: { required: true, min: 3 },
    aka: { min: 2 },
    phone1: { required: true, min: 14, max: 16 },
    phone2: { min: 14, max: 16 }
  },
  additionalData: {
    street: { required: true },
    number: { required: true },
    neighborhood: { required: true },
    city: { required: true },
    zip: { required: true, min: 9 },
    complement: { required: true },
    nis: { required: false, min: 11, max: 11 },
    regularity: { required: false }
  }
}
let getters = { ...mapGetters() }
getters[singleName] = (state) => {
  return Object.assign({}, model, state.one)
}
getters[pluralName] = state => state.all
getters = Object.assign(getters, {
  loading: state => state.loading,
  validations: state => state.validations,
  count: state => state.count
})
export default {
  namespaced: true,
  state: {
    ...mapStates(),
    loading: false,
    all: [],
    one: Object.assign({}, model),
    validations: validations,
    count: 0,
    urlImages: {}
  },
  mutations: {
    ...mapMutations(),

    SET_IMAGES_URL: function (state, payload) {
      state.urlImages = Object.assign(state.urlImages, payload)
    },

    setAllAppend: (state, payload) => {
      let byId = state.all.reduce((acc, curr, indx) => {
        if (indx === 0) {
          acc = {}
        }
        acc[curr._id] = curr._id
        return acc
      }, {})

      let all = state.all

      payload.filter(item => !byId.hasOwnProperty(item._id))
        .map(item => all.push(item))

      state.all = all
    }
  },
  actions: {
    ...mapActions(collection, model),

    // Versão que não utiliza-se dos join do couch, fazendo multiplas consultas e retornando tudo para seu respectivo "vuex"
    fetchAllData ({ commit, dispatch }, { id, options }) {
      commit('changeLoading', true)
      let keys = { startKey: id, startIndex: 0, endKey: id, endIndex: 6 }
      Couchdb.connection('default')
        ._viewBetween('join-customer-datas', 'join-customer-datas', keys, {
          include_docs: true,
          inclusive_end: true,
          reduce: false,
          skip: 0,
          limit: 50
        })
        .then(docs => {
          if (docs.rows.length <= 0) {
            return
          }

          let tickets = []
          let events = []
          let stocks = []
          let lamps = []

          for (let row of docs.rows) {
            let doc = row.doc
            let key = row.key[1]
            if (key === 0) {
              // customer
              commit('setOne', Object.assign({}, doc))
            }

            if (key === 1) {
              tickets.push(doc)
            } else if (key === 2 || key === 5) {
              events.push(doc)
            } else if (key === 3) {
              stocks.push(doc)
            } else if (key === 4) {
              lamps.push(doc)
            }
          }

          if (!options || options.tickets !== false) {
            dispatch('tickets/setStateAll', tickets, { root: true })
          }
          if (!options || options.events !== false) {
            dispatch('events/setStateAll', events, { root: true })
          }
          if (!options || options.stocks !== false) {
            dispatch('stocks/setStateAll', stocks, { root: true })
          }
          if (!options || options.lamps !== false) {
            dispatch('lamps/setStateAll', lamps, { root: true })
          }

          commit('changeLoading', false)
        })
        .catch(err => console.log(err))
        .finally(() => commit('changeLoading', false))
    },

    fetchCustomerDatas ({ commit, dispatch }, { id }) {
      commit('changeLoading', true)
      let keys = { startKey: id, startIndex: 0, endKey: id, endIndex: 6 }
      Couchdb.connection('default')
        ._viewBetween('join-customer-datas', 'join-customer-datas', keys, {
          include_docs: true,
          inclusive_end: true,
          reduce: false,
          skip: 0,
          limit: 50
        })
        .then(docs => {
          let customer = { tickets: [], lamps: [] }
          if (docs.rows.length > 0) {
            for (let row of docs.rows) {
              let doc = row.doc
              let key = row.key[1]
              if (key === 0) {
                // customer
                customer = Object.assign(customer, doc)
              }

              if ([1, 2, 3].indexOf(key) !== -1) {
                if (key === 1) {
                  customer.tickets.push(doc)
                } else {
                  customer.tickets = customer.tickets.map(item => {
                    if (item.eventId === doc._id) {
                      item.event = doc
                    } else if (item.stockId === doc._id) {
                      item.stock = doc
                    }
                    return item
                  })
                }
              }

              if ([4, 5].indexOf(key) !== -1) {
                if (key === 4) {
                  customer.lamps.push(doc)
                }
                if (key === 5) {
                  customer.lamps = customer.lamps.map(item => {
                    if (item.eventId === doc._id) {
                      item.event = doc
                    }
                    return item
                  })
                }
              }
            }
          }
          commit('setOne', customer)
          commit('changeLoading', false)
        })
        .catch(err => console.log(err))
        .finally(() => commit('changeLoading', false))
    },

    async searchCustomer ({ commit }, { query, options }) {
      commit('setAll', [])
      let queryTest = query.replace(/\W+/g, '')
      if (queryTest.replace(/\D+/g, '') !== '') {
        await Couchdb.connection('default')
          .viewBetween('customers-by-uc', 'customers-by-uc', {
            startKey: query.replace(/\D+/g, ''),
            endKey: query.replace(/\D+/g, ''),
            endIndex: '{}'
          }, options)
          .then(response => {
            commit('setAllAppend', response.rows.map(item => item.value).filter(item => item.uc.indexOf(query) === 0))
          })
          .catch(err => console.log(err))

        await Couchdb.connection('default')
          .viewBetween('customers-by-uc', 'customers-by-uc', {
            startKey: query.replace(/\D+/g, ''),
            endKey: query.replace(/\D+/g, ''),
            endIndex: '{}'
          }, options)
          .then(response => {
            commit('setAllAppend', response.rows.map(item => item.value).filter(item => item.cpf.indexOf(query) === 0))
          })
          .catch(err => console.log(err))
      }

      if (queryTest.replace(/\d+/g, '')) {
        await Couchdb.connection('default')
          .viewBetween('customers-by-holder', 'customers-by-holder', {
            startKey: query.toUpperCase(),
            endKey: query.toUpperCase(),
            endIndex: '{}'
          }, options)
          .then(response => {
            commit('setAllAppend', response.rows.map(item => item.value).filter(item => item.holder.indexOf(query) === 0))
          })
          .catch(err => console.log(err))

        await Couchdb.connection('default')
          .viewBetween('customers-by-holder', 'customers-by-holder', {
            startKey: query,
            endKey: query,
            endIndex: '{}'
          }, options)
          .then(response => {
            commit('setAllAppend', response.rows.map(item => item.value).filter(item => item.holder.indexOf(query) === 0))
          })
          .catch(err => console.log(err))
      }
    },

    getUrlImg ({ commit }, { id }) {
      const baseURL = `${connections.default.host}/${connections.default.db}/${id}`
      commit(
        'SET_IMAGES_URL',
        {
          image: `${baseURL}/image.jpg`
        }
      )
      return {
        image: `${baseURL}/image.jpg`
      }
    },

    resetUrlImg ({ commit }) {
      commit('SET_IMAGES_URL', {})
    },

    uploadCustomerImage (context, { id, mimeType, name, attachment }) {
      return Couchdb.connection('default')
        .insertAttachment(id, {
          mimeType: mimeType,
          attachmentName: name,
          attachment: attachment
        })
    },

    fetchParticipantCount (context, { eventsId }) {
      return Couchdb.viewQueries({
        connection: 'default',
        ddoc: 'count-participants-event',
        view: 'count-participants-event',
        queries: eventsId.map(id => ({
          reduce: true,
          group_level: 2,
          inclusive_end: true,
          start_key: [id],
          end_key: [id, {}]
        }))
      }).then(result => {
        const count = result.reduce((acc, curr) => {
          return acc + curr.rows.length
        }, 0)
        context.commit('SET_DASHBOARD_COUNTER', count)
        return count
      })
        .catch(a => console.log(a))
    }
  },
  getters: {
    ...getters,
    urlImgs: state => state.urlImages,
    addressCustomer: state => {
      let addr = ''
      if (state.one.address.hasOwnProperty('street')) {
        addr += state.one.address.street
      }
      if (state.one.address.hasOwnProperty('number')) {
        addr += addr !== '' ? ', ' + state.one.address.number : state.one.address.number
      }
      if (state.one.address.hasOwnProperty('complement')) {
        addr += addr !== '' ? ', ' + state.one.address.complement : state.one.address.complement
      }
      if (state.one.address.hasOwnProperty('neighborhood')) {
        addr += addr !== '' ? ', ' + state.one.address.neighborhood : state.one.address.neighborhood
      }
      if (state.one.address.hasOwnProperty('city')) {
        addr += addr !== '' ? ', ' + state.one.address.city : state.one.address.city
      }
      if (state.one.address.hasOwnProperty('zip')) {
        addr += addr !== '' ? ', ' + state.one.address.zip : state.one.address.zip
      }
      return addr
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/customers.js